import React from 'react';
import { Button } from 'react-bootstrap';

/**
 * What a table says when it has no rows to show. When a search or filter
 * emptied it, the message names that and offers the way back; otherwise it
 * shows `emptyText`.
 */
export default function TableEmpty({
    controls,
    noun,
    emptyText,
    clearLabel = 'Clear filters',
}) {
    if (controls.rows.length > 0) return null;
    if (!controls.filtersActive) {
        return (
            <div className="text-center py-5 text-muted" role="status">
                {emptyText}
            </div>
        );
    }
    return (
        <div className="text-center py-5 text-muted" role="status">
            <p className="mb-2">No {noun} match your search or filter.</p>
            <Button
                variant="outline-primary"
                size="sm"
                onClick={controls.clearFilters}
            >
                {clearLabel}
            </Button>
        </div>
    );
}
